import { styled } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import DashboardCustomizeRoundedIcon from "@mui/icons-material/DashboardCustomizeRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { AppLogo } from "components/appLogo";
import {
  AppMenu,
  CloseMenuButton,
  DrawerContent,
  MobileDrawer,
  MobileMenuItem,
  MobileMenuNav,
} from "./styled";
import { TonConnectButton } from "@tonconnect/ui-react";
import { useNavigatePreserveQuery } from "lib/hooks/useNavigatePreserveQuery";
import { useLocation } from "react-router-dom";
import { ROUTES } from "consts";

interface MenuProps {
  closeMenu?: () => void;
  showMenu?: boolean;
}

const MobileMenu: React.FC<MenuProps> = ({ closeMenu, showMenu }) => {
  const navigate = useNavigatePreserveQuery();
  const location = useLocation();

  const manageClick = () => {
    navigate(ROUTES.management);
    closeMenu && closeMenu();
  };

  const manageClickHome = () => {
    navigate(ROUTES.deployer);
    closeMenu && closeMenu();
  };

  return (
    <MobileDrawer anchor="left" open={showMenu} onClose={closeMenu}>
      <DrawerContent>
        <div onClick={closeMenu}>
          <AppLogo />
        </div>
        <CloseMenuButton aria-label="关闭菜单" onClick={closeMenu}>
          <CloseRoundedIcon />
        </CloseMenuButton>
      </DrawerContent>
      <MobileMenuNav component="nav" aria-label="移动端主菜单">
        <MobileMenuItem
          aria-current={location.pathname === ROUTES.deployer ? "page" : undefined}
          onClick={manageClickHome}
        >
          <AddCircleOutlineRoundedIcon />
          <span>创建代币</span>
          <ChevronRightRoundedIcon className="menu-arrow" />
        </MobileMenuItem>
        <MobileMenuItem
          aria-current={location.pathname === ROUTES.management ? "page" : undefined}
          onClick={manageClick}
        >
          <DashboardCustomizeRoundedIcon />
          <span>管理代币</span>
          <ChevronRightRoundedIcon className="menu-arrow" />
        </MobileMenuItem>
      </MobileMenuNav>
    </MobileDrawer>
  );
};

const HeaderMenu: React.FC<MenuProps> = (props) => {
  return (
    <AppMenu>
      <div onClick={props.closeMenu}>
        <StyledTonConnectButton />
      </div>
      {/* <IconButton
        sx={{ padding: 0, ml: 1.5 }}
        href="https://github.com/ton-blockchain/minter"
        target="_blank">
        <StyledGithubIcon width={20} height={20} src={githubIcon} />
        <HeaderTypography variant="h5">GitHub</HeaderTypography>
      </IconButton> */}
    </AppMenu>
  );
};

const StyledTonConnectButton = styled(TonConnectButton)(({ theme }) => ({
  button: {
    background: theme.palette.primary.main,
    "*": { color: "white" },
    svg: {
      "*": {
        stroke: "white",
      },
    },
  },
}));

export { HeaderMenu, MobileMenu, StyledTonConnectButton };
